import { createReducer, makeActionCreator } from 'utils/reduxCreators';

export const UPDATE_APP_HTTP_ERROR = 'meta/UPDATE_APP_HTTP_ERROR';
export const RESET_APP_HTTP_ERROR = 'meta/RESET_APP_HTTP_ERROR';
export const UPDATE_APP_LOADER = 'meta/UPDATE_APP_LOADER';
export const UPDATE_SIDE_BAR_OPEN = 'meta/UPDATE_SIDE_BAR_OPEN';

export const initialState = {
  httpError: null,
  appLoading: false,
  isSideBarOpen: false, //Need to show\hide some UI based on the state of the side bar.
};

export default createReducer(initialState, {
  [UPDATE_APP_HTTP_ERROR]: (state, action) => {
    const { payload } = action;
    return {
      ...state,
      httpError: payload,
    };
  },
  [RESET_APP_HTTP_ERROR]: (state) => {
    return {
      ...state,
      httpError: null,
    };
  },
  [UPDATE_APP_LOADER]: (state, { payload }) => {
    return {
      ...state,
      appLoading: payload,
    };
  },
  [UPDATE_SIDE_BAR_OPEN]: (state, { payload }) => {
    return {
      ...state,
      isSideBarOpen: payload,
    };
  },
});

export const updateHttpError = (errorResponse) => async (dispatch) => {
  const responseJson = await errorResponse.json();
  const action = {
    type: UPDATE_APP_HTTP_ERROR,
    payload: {
      status: errorResponse.status,
      statusText: responseJson.errorText || '',
      validationErrors: responseJson.validationErrors,
    },
  };
  dispatch(action);
};

export const resetHttpError = makeActionCreator(RESET_APP_HTTP_ERROR);

export const updateAppLoading = makeActionCreator(UPDATE_APP_LOADER);

export const updateIsSideBarOpen = makeActionCreator(UPDATE_SIDE_BAR_OPEN);
